// Design tokens for the What's New feed, lifted verbatim from the design SoT
// (TransferPitch Whats New.dc.html). Kept in one place so the card, reaction
// bar and poll all read from the same source and stay pixel-consistent.

// The curated reaction set — keys are the API contract (D-005), order is the
// design's bar order. Emoji + tooltip titles match the prototype exactly.
export const REACTIONS = [
  { key: "up", emoji: "👍", title: "Useful" },
  { key: "party", emoji: "🎉", title: "Love it" },
  { key: "ball", emoji: "⚽", title: "On the pitch" },
  { key: "eyes", emoji: "👀", title: "Watching this" },
  { key: "heart", emoji: "💙", title: "Big fan" },
];

export const REACTION_KEYS = REACTIONS.map((r) => r.key);

// Category chip styling. Backend `category` ∈ {new_feature, improvement,
// announcement, poll}; label + colours from the prototype's chips.
export const CATEGORY_CHIPS = {
  new_feature: { label: "NEW FEATURE", bg: "#E9F2FF", color: "#1668D9" },
  improvement: { label: "IMPROVEMENT", bg: "#E4F4ED", color: "#0E7F5B" },
  announcement: { label: "ANNOUNCEMENT", bg: "#EFECFA", color: "#6A55C9" },
  poll: { label: "POLL", bg: "#FAF1DC", color: "#8A6100" },
};

// Neutral chips (pinned / closed) share this muted palette.
export const NEUTRAL_CHIP = { bg: "#EEF2F7", color: "#5A6B82" };
